export default __webpack_public_path__ + "static/media/about-banner.2b9aa12c.jpg";